import React from 'react';

import { observer } from 'mobx-react';
import { linearModel } from 'mobx-store';

import ModelSummaryTable from './ModelSummaryTable';
import CoefficientSummaryTable from './CoefficientSummaryTable';
import { SCATTER_PLOT_TYPES } from 'mobx-store/linearModel';

const BottomPaneComponent = observer(
  class BottomPaneComponent extends React.Component {

    isProbabilityPlotGraph = () =>
      linearModel.visibleScatterPlotType === SCATTER_PLOT_TYPES.NORMAL

    render () {
      return (
        [
          <ModelSummaryTable
            key="model-summary"
            {...linearModel.modelSummary}
          />,

          <CoefficientSummaryTable
            key="coefficient-summary"
            coefficientSummary={linearModel.coefficientSummary}
            isProbabilityPlot={this.isProbabilityPlotGraph()}
          />
        ]
      );
    }
  }
);

export default BottomPaneComponent;
